import { render, staticRenderFns } from "./InspectionDashBoard.vue?vue&type=template&id=60ff94a2&scoped=true&"
import script from "./InspectionDashBoard.vue?vue&type=script&lang=js&"
export * from "./InspectionDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./InspectionDashBoard.vue?vue&type=style&index=0&id=60ff94a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ff94a2",
  null
  
)

export default component.exports